// extracted by mini-css-extract-plugin
module.exports = {"answers":"Answers_answers__2tC6Z","answer":"Answers_answer__2cAN1","correct":"Answers_correct__2I_h4","wrong":"Answers_wrong__2jzZU"};